import {
  API_ERROR,
  SELECT_CHANGEVALUE,
  PO_LIST,
  PO_LIST_SUCCESS,
  ADD_PO_DATA,
  IGP_ADD,
  IGP_ITEM_SELECT,
  IGP_LIST,
  IGP_LIST_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  TOGGLE_ITEM_MENU,
  IGP_ROW_DATA,
  IGP_ROW_DATA_SUCCESS,
  INPUT_CHANGEVALUE,
  IGP_INPUT_CHANGEVALUE,
  LIST_LAYOUT,
  PO_ITEM_LIST,
  PO_ITEM_LIST_SUCCESS,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNITES_CHANGEVALUE,
  PO_ITEM_MODEL_CLOSE,
  IGP_ADD_PO_DATA,
  IGP_PO_DATA_REMOVE,
  PREVIEW_IMAGE,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IGP_IMAGE,
  UPLOAD_IGP_IMAGE_SUCCESS,
} from "./actionTypes";

export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getPOList = (data) => {
  return {
    type: PO_LIST,
    payload: { data },
  };
};
export const getPOListSuccessful = (response) => {
  return {
    type: PO_LIST_SUCCESS,
    payload: response,
  };
};

export const AddPOdata = (Podata) => {
  return {
    type: ADD_PO_DATA,
    payload: { Podata },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const IgpInputChangeValue = ({ key, value }) => {
  return {
    type: IGP_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const IGPItemSelect = (checked, item, index) => {
  return {
    type: IGP_ITEM_SELECT,
    payload: { checked, item, index },
  };
};
export const IGPAdd = (data, IGPId, history) => {
  return {
    type: IGP_ADD,
    payload: { data, IGPId, history },
  };
};
export const getIGPList = (data) => {
  return {
    type: IGP_LIST,
    payload: { data },
  };
};
export const IGPListSuccessful = (response) => {
  return {
    type: IGP_LIST_SUCCESS,
    payload: response,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const getIGPRowData = (IGPId) => {
  return {
    type: IGP_ROW_DATA,
    payload: { IGPId },
  };
};
export const IGPDatasuccessfull = (response) => {
  return {
    type: IGP_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const getPOItemsList = (PoID) => {
  return {
    type: PO_ITEM_LIST,
    payload: { PoID },
  };
};
export const getPOItemsListSuccess = (response) => {
  return {
    type: PO_ITEM_LIST_SUCCESS,
    payload: response,
  };
};
export const PreviewImage = (imageFile) => {
  return {
    type: PREVIEW_IMAGE,
    payload: { imageFile },
  };
};
export const IGPImageUpload = (ImageFile, ImageType) => {
  return {
    type: UPLOAD_IGP_IMAGE,
    payload: { ImageFile, ImageType },
  };
};
export const IGPImageUploadSuccess = (ImageData, ImageType) => {
  return {
    type: UPLOAD_IGP_IMAGE_SUCCESS,
    payload: { ImageData, ImageType },
  };
};
export const UploadImage = (ImageType, ImageFile, callback) => {
  return {
    type: UPLOAD_IMAGE,
    payload: { ImageType, ImageFile, callback },
  };
};
export const UploadImageSuccess = (ImageType, Image) => {
  return {
    type: UPLOAD_IMAGE_SUCCESS,
    payload: { ImageType, Image },
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const ItemQtyChangeValue = ({ key, value, item, status }) => {
  return {
    type: ITEM_QTY_CHANGEVALUE,
    payload: { key, value, item, status },
  };
};
export const ItemUnitsChangeValue = ({ label, value, item, status }) => {
  return {
    type: ITEM_UNITES_CHANGEVALUE,
    payload: { label, value, item, status },
  };
};
export const poItemsModel_close = () => {
  return {
    type: PO_ITEM_MODEL_CLOSE,
    payload: null,
  };
};
export const IGPAddPOdata = (data) => {
  return {
    type: IGP_ADD_PO_DATA,
    payload: data,
  };
};
export const IGPPODataRemove = (data) => {
  return {
    type: IGP_PO_DATA_REMOVE,
    payload: data,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
//--------------------
